export interface IWrappedComponent<T> {
  wrappedComponent: React.ComponentType<T>;
}

export const applyWrappedComponent = <T extends U, U extends object>(
  Comp: React.ComponentType<T>,
  WrappedComp: React.ComponentType<U>,
  name: string
): React.ComponentType<T> & IWrappedComponent<U> => {
  const namedComp =
    (WrappedComp as any as React.MemoExoticComponent<React.ComponentType<U>>).type ?? WrappedComp;
  return Object.defineProperties(Comp, {
    wrappedComponent: {
      get: () => WrappedComp,
      set: Function.NOOP
    },
    displayName: {
      get: () => {
        return `${name}(${namedComp.displayName})`;
      },
      set: Function.NOOP
    }
  }) as React.ComponentType<T> & IWrappedComponent<U>;
};
